import {
    BLOOD_TEST_ENDPOINT,
    REST_BLOOD_TEST_ENDPOINT,
    EXERCISE_BLOOD_TEST_ENDPOINT,
} from "../../endpoints";
import { fetcher } from "../../utils";
import { BloodTestUpdateData } from "./types";
import { convertBloodTestApiResponsesToFormValues } from "./converters";

export const getBloodTestData = async ({ testId }: { testId: string }) => {
    const response = await fetcher(BLOOD_TEST_ENDPOINT, {
        params: { test_id: testId },
    });

    return response as BloodTestUpdateData | null;
};

export const getRestBloodTestData = async ({ testId }: { testId: string }) => {
    const response = await fetcher(REST_BLOOD_TEST_ENDPOINT, {
        params: { test_id: testId },
    });

    return response as BloodTestUpdateData | null;
};

export const submitRestBloodTestData = async ({
    testId,
    values,
}: {
    testId: string;
    values: BloodTestUpdateData;
}) => {
    const response = await fetcher(
        REST_BLOOD_TEST_ENDPOINT,
        {
            method: "PUT",
            data: values,
            params: { test_id: testId },
        },
        true
    );

    return response as BloodTestUpdateData;
};

export const getExerciseBloodTestData = async ({
    testId,
}: {
    testId: string;
}) => {
    const response = await fetcher(EXERCISE_BLOOD_TEST_ENDPOINT, {
        params: { test_id: testId },
    });

    return response as BloodTestUpdateData | null;
};

export const submitExerciseBloodTestData = async ({
    testId,
    values,
}: {
    testId: string;
    values: BloodTestUpdateData;
}) => {
    const response = await fetcher(
        EXERCISE_BLOOD_TEST_ENDPOINT,
        {
            method: "PUT",
            data: values,
            params: { test_id: testId },
        },
        true
    );

    return response as BloodTestUpdateData;
};

export const getRestAndExerciseBloodTestData = async ({
    testId,
}: {
    testId: string;
}) => {
    const [restData, exerciseData] = await Promise.all([
        getRestBloodTestData({ testId }),
        getExerciseBloodTestData({ testId }),
    ]);

    if (!restData || !exerciseData) {
        return null;
    }

    const data = convertBloodTestApiResponsesToFormValues(restData, exerciseData);
    return data;
};
